import { z } from 'zod';

export const TenantIntegrationConfiguration = z.object({
  integrator: z.string().describe('The integration type (FK to integration.integrator)'),
  version: z.string().describe('The integration version (FK to integration.version)'),
}).describe('The configuration for a specific tenant integration maintained in backoffice.');

export const IntegrationConfiguration = z.object({
  images: z.record(
    z.string(),
    z.object({
      name: z.string().describe('The name of the image'),
      tag: z.string().describe('The version of the image'),
      digest: z
        .string()
        .optional()
        .describe('The digest of the image, if this is specified this will used to pull the image'),
    }).strict(),
  ),
}).describe('The configuration for the integration maintained in backoffice. Configures the images used for the integration and whether to use the local tileserver or the integrator API for slide requests.');

export const Integration = z.object({
  integrator: z.string().describe('The integration type'),
  version: z.string().describe('The integration version'),
  configuration: IntegrationConfiguration,
}).describe('The integration maintained in backoffice, each integration type & version combination has its own set of configuration options.');

export type IntegrationConfigurationType = z.infer<typeof IntegrationConfiguration>;

export type IntegrationType = z.infer<typeof Integration>;
